import { render, staticRenderFns } from "./New-Ai-Request-Step2.vue?vue&type=template&id=701c0617&scoped=true&"
import script from "./New-Ai-Request-Step2.vue?vue&type=script&lang=js&"
export * from "./New-Ai-Request-Step2.vue?vue&type=script&lang=js&"
import style0 from "./New-Ai-Request-Step2.vue?vue&type=style&index=0&id=701c0617&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701c0617",
  null
  
)

export default component.exports